// removed by extract-text-webpack-plugin
module.exports = {"empty":"empty__empty__2GoQ3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DataTable/Body/Empty/empty.css
// module id = 1640
// module chunks = 0